import { render } from "./AdminSkills.vue?vue&type=template&id=0b4ab0ac"
import script from "./AdminSkills.vue?vue&type=script&lang=js"
export * from "./AdminSkills.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__